const tmHome = {
  total: 5,
  data: [
    {
      id: 121,
      name: "Navbar",
      templateType: "Navbar",
      location: 0,
      elements: [],
      sections: [
        {
          name: "base",
          order: 1,
          contentType: "Category",
          categories: [
            {
              id: 3,
              text: "Foto galeri",
              subCategories: [
                {
                  id: 4,
                  text: "FOTOĞRAFLAR",
                  elements: [],
                },
                {
                  id: 5,
                  text: "VİDEOLAR",
                  elements: [],
                },
              ],
              elements: [],
            },
            {
              id: 2,
              text: "hakkimda",
              elements: [],
            },
            {
              id: 1,
              text: "Haberler",
              elements: [],
            },
            {
              id: 6,
              text: "ulasim",
              elements: [],
            },
          ],
        },
      ],
    },
    {
      id: 122,
      name: "ViranSehirHaberler",
      templateType: "Card",
      location: 0,
      elements: [],
      sections: [
        {
          name: "left",
          order: 1,
          contentType: "Content",
          categories: [
            {
              id: 1,
              text: "Haberler",
              elements: [],
              contents: [
                {
                  id: 427,
                  title:
                    "ANKARA’DA İKAMET EDEN VİRANŞEHİRLİ HEMŞEHRİMİZ İŞ İNSANI SUPHİ ÖZTOP’U İLÇE BAŞKAN YARDIMCIMIZ SUPHİ PALMANAK İLE BİRLİKTE İŞYERİNDE ZİYARET ETTİK",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Ankara&rsquo;da ikamet eden Viranşehirli hemşehrimiz İş İnsanı Suphi &Ouml;ztop&rsquo;u İl&ccedil;e Başkan Yardımcımız Suphi Palmanak ile birlikte işyerinde ziyaret ederek, hasbihal ettik.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Kıymetli hemşehrimize bize g&ouml;sterdikleri yakın ilgi ve misafirperverliklerinden &ouml;t&uuml;r&uuml; teşekk&uuml;r ediyor, kendilerine sağlıklı, huzurlu, uzun &ouml;m&uuml;rler diliyorum.</span></p>',
                  description:
                    "Kıymetli hemşehrimize bize gösterdikleri yakın ilgi ve misafirperverliklerinden ötürü teşekkür ediyor, kendilerine sağlıklı, huzurlu, uzun ömürler diliyorum.",
                  editDate: "2023-06-05T08:10:14",
                  imageName: "230605_081110_4302311.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 426,
                  title:
                    "EN KRİTİK DÖNEMLERİN 17-25 ARALIK VE 15 TEMMUZ SÜRECİNİN ADALET BAKANI",
                  details:
                    "<p class=\"MsoNormal\"><span style=\"font-family: 'Times New Roman','serif';\">15 Temmuz&rsquo;da Gazi Meclisimizde bombalara meydan okuyan yiğit adam Bekir Bozdağ Adalet Bakanlığı g&ouml;revini alnının akıyla tamamladı.</span></p>\n<p class=\"MsoNormal\"><span style=\"font-family: 'Times New Roman','serif';\">Adalet Bakanlığı g&ouml;revini bug&uuml;ne kadar b&uuml;y&uuml;k bir başarı ile y&uuml;r&uuml;ten ve &ouml;nemli başarılara imza atan Sn. Bekir Bozdağ&rsquo;a g&uuml;zel hizmetleri i&ccedil;in teşekk&uuml;r ediyorum.</span></p>\n<p class=\"MsoNormal\"><span style=\"font-family: 'Times New Roman','serif';\">Y&uuml;ce Rabbim, TBMM de hayırlı hizmetler yapmayı nasip etsin. Durmak yok T&uuml;rkiye Y&uuml;zyılı i&ccedil;in &ccedil;alışmaya devam. Bekir Bozdağ</span></p>",
                  description:
                    "Adalet Bakanlığı görevini bugüne kadar büyük bir başarı ile yürüten ve önemli başarılara imza atan Sn. Bekir Bozdağ’a güzel hizmetleri için teşekkür ediyorum.",
                  editDate: "2023-06-05T08:09:14",
                  imageName: "230605_081006_2997433.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 425,
                  title:
                    "HAZİNE VE MALİYE BAKANLIĞI'NDA GÖREV DEVİR TESLİM TÖRENİNE İLÇE BAŞKAN YARDIMCIMIZ SUPHİ PALMANAK İLE BİRLİKTE KATILDIK",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Hazine ve Maliye Bakanlığı\'nda g&ouml;rev devir teslim t&ouml;renine İl&ccedil;e Başkan Yardımcımız Suphi Palmanak ile birlikte katıldık.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">G&ouml;revi devralan Hazine ve Maliye Bakanımız Sn. Mehmet Şimşek&rsquo;i tebrik ediyor, yeni g&ouml;revinde muvaffakiyetler diliyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Hazine ve Maliye Bakanlığı g&ouml;revini bug&uuml;ne kadar b&uuml;y&uuml;k bir başarı ile y&uuml;r&uuml;ten ve &ouml;nemli başarılara imza atan Viranşehirli Hemşehrimiz, değerli b&uuml;y&uuml;ğ&uuml;m&uuml;z Sn. Dr. Nureddin Nebati&rsquo;ye de g&uuml;zel hizmetleri i&ccedil;in teşekk&uuml;r ediyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Y&uuml;ce Rabbim, hayırlı hizmetlerde bulunmayı nasip eylesin. &Uuml;lkemize ve aziz milletimize hayırlı, uğurlu olsun.</span></p>',
                  description:
                    "Görevi devralan Hazine ve Maliye Bakanımız Sn. Mehmet Şimşek’i tebrik ediyor, yeni görevinde muvaffakiyetler diliyorum.",
                  editDate: "2023-06-05T08:07:00",
                  imageName: "230605_080841_9943036.webp",
                  imageCount: 2,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [
                    "230605_080854_1280843.webp",
                    "230605_080854_1117107.webp",
                  ],
                },
                {
                  id: 424,
                  title:
                    "CUMHURBAŞKANIMIZ VE GENEL BAŞKANIMIZ SN. RECEP TAYYİP ERDOĞAN'IN TAKDİR VE TENSİPLERİYLE OLUŞAN TÜRKİYE YÜZYILI’NIN CUMHURBAŞKANLIĞI KABİNESİ",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Cumhurbaşkanımız ve Genel Başkanımız Sn. Recep Tayyip Erdoğan\'ın takdir ve tensipleriyle oluşan T&uuml;rkiye Y&uuml;zyılı&rsquo;nın Cumhurbaşkanlığı Kabinesi &uuml;lkemize ve aziz milletimize hayırlı, uğurlu olsun. </span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Cumhurbaşkanlığı Kabinesi\'nde g&ouml;rev alan kıymetli Bakanlarımızı tebrik ediyor, g&ouml;revlerinde muvaffakiyetler diliyorum.</span></p>',
                  description:
                    "Cumhurbaşkanlığı Kabinesi'nde görev alan kıymetli Bakanlarımızı tebrik ediyor, görevlerinde muvaffakiyetler diliyorum.",
                  editDate: "2023-06-05T08:05:58",
                  imageName: "230605_080616_3925363.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 423,
                  title:
                    "YARIN LİSELERE GEÇİŞ SINAVINA (LGS) GİRECEK OLAN TÜM KIYMETLİLERİMİZE BAŞARILAR, SINAV GÖREVLİLERİNE KOLAYLIKLAR DİLİYORUM",
                  details:
                    "<p class=\"MsoNormal\"><span style=\"font-family: 'Times New Roman','serif';\">YARIN LİSELERE GE&Ccedil;İŞ SINAVINA (LGS) GİRECEK OLAN T&Uuml;M KIYMETLİLERİMİZE BAŞARILAR, SINAV G&Ouml;REVLİLERİNE KOLAYLIKLAR DİLİYORUM.</span></p>\n<p class=\"MsoNormal\"><span style=\"font-family: 'Times New Roman','serif';\">Rabbim zihin a&ccedil;ıklığı versin, her şey g&ouml;nl&uuml;n&uuml;zce olsun&hellip;</span></p>",
                  description:
                    "Rabbim zihin açıklığı versin, her şey gönlünüzce olsun…",
                  editDate: "2023-06-05T08:05:04",
                  imageName: "230605_080532_5883394.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 422,
                  title:
                    "BİZ BİRLİKTE GÜÇLÜYÜZ, BİRLİKTE KUVVETLİYİZ, BİRLİKTE DİRAYETLİYİZ",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Biz birlikte g&uuml;&ccedil;l&uuml;y&uuml;z, birlikte kuvvetliyiz, birlikte dirayetliyiz.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">İl&ccedil;e Başkanımız Ali Tekin ve y&ouml;netim kurulu &uuml;yeleri ile birlikte AK Parti Şanlıurfa Milletvekilimiz Sn. Cevahir Asuman Yazmacı&rsquo;nın milletvekili yemin t&ouml;reni sonrası TBMM&rsquo;de bir araya geldik.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Cumhurbaşkanımız ve Genel Başkanımız Sn. Recep Tayyip Erdoğan&rsquo;ın liderliğinde, kadim şehir Viranşehir&rsquo;imize birlik ve beraberlik i&ccedil;erisinde hareket ederek hizmetlerimizi yapacağız.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Millete hizmet aşkıyla, "B&uuml;y&uuml;k ve G&uuml;&ccedil;l&uuml; T&uuml;rkiye" yolunda, Rabbim birlik ve beraberliğimizi daim ve kaim eylesin.</span></p>',
                  description:
                    "İlçe Başkanımız Ali Tekin ve yönetim kurulu üyeleri ile birlikte AK Parti Şanlıurfa Milletvekilimiz Sn. Cevahir Asuman Yazmacı’nın milletvekili yemin töreni sonrası TBMM’de bir araya geldik.",
                  editDate: "2023-06-05T08:03:51",
                  imageName: "230605_080423_4049577.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 421,
                  title:
                    "AK PARTİ GENEL MERKEZ YEREL YÖNETİMLER BAŞKAN YARDIMCIMIZ VE ŞANLIURFA KOORDİNATÖRÜMÜZ SN. AYŞE SULA KÖSEOĞLU HANIMEFENDİ’Yİ ZİYARET EDEREK ETTİK",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">AK Parti Genel Merkez Yerel Y&ouml;netimler Başkan Yardımcımız ve Şanlıurfa Koordinat&ouml;r&uuml;m&uuml;z Sn. Ayşe Sula K&ouml;seoğlu Hanımefendi&rsquo;yi ziyaret ederek, il&ccedil;emizde yapılacak olan proje ve yatırımlar hakkında gayet verimli bir g&ouml;r&uuml;şme ger&ccedil;ekleştirdik.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Kıymetli Başkanımız Sn. Ayşe Sula K&ouml;seoğlu Hanımefendiye bize g&ouml;sterdikleri yakın ilgi, alaka ve desteklerinden &ouml;t&uuml;r&uuml; teşekk&uuml;r ediyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Mehmet &Ouml;zhaseki Ayşe Sula K&ouml;seoğlu</span></p>',
                  description:
                    "Kıymetli Başkanımız Sn. Ayşe Sula Köseoğlu Hanımefendiye bize gösterdikleri yakın ilgi, alaka ve desteklerinden ötürü teşekkür ediyorum.",
                  editDate: "2023-06-05T08:01:59",
                  imageName: "230605_080258_3756711.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 420,
                  title:
                    "14 MAYIS MİLLETVEKİLİ SEÇİMLERİNDE AK PARTİ ŞANLIURFA MİLLETVEKİLİ SEÇİLEN CEVAHİR ASUMAN YAZMACI’YA HAYIRLI OLSUN ZİYARETİNDE BULUNDUK.",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">14 Mayıs Milletvekili se&ccedil;imlerinde AK Parti Şanlıurfa Milletvekili se&ccedil;ilen Cevahir Asuman Yazmacı&rsquo;ya hayırlı olsun ziyaretinde bulunduk.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Bir dizi ziyaret ve temaslarda bulunmak &uuml;zere Ankara&rsquo;da bulunduk Vekillerin yemin t&ouml;reni &ouml;ncesi T&uuml;rkiye B&uuml;y&uuml;k Millet Meclisinde (TBMM) bir dizi ziyaretler ger&ccedil;ekleştirdik.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Ziyaretler kapsamında ilk &ouml;nce 14 Mayıs Milletvekili se&ccedil;imlerinde AK Partiden Şanlıurfa/Viranşehir Milletvekili se&ccedil;ilen Cevahir Asuman Yazmacı&rsquo;yı ziyaret ederek, hayırlı olsun dileklerini ilettik.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Vekil Yazmacı&rsquo;ya yeni g&ouml;revinde başarılarılarının devamını diledik. Viranşehir il&ccedil;e tarihinde ilk defa Viranşehir&rsquo;de partilerinden bir kadın vekilin &ccedil;ıkmasından dolayı memnuniyetimizi dile getirdik. </span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Viranşehir belediye Başkanı olarak, Viranşehir&rsquo;in kıymetli kızı, bacısı ve ablası ile birlikte g&uuml;zel hizmetlere imza atacağını belirttik. </span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Milletvekili Asuman Yazmacı, ziyaretten dolayı &ccedil;ok memnun olduğunu belirtti ve teşekk&uuml;r etti.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Ziyaretimizin ardından TBMM&rsquo;de Şanlıurfa AK Parti Milletvekillerini ziyaret ederek, hayırlı olsun dileklerinde bulunduk.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">&nbsp;</span></p>',
                  description:
                    "Vekil Yazmacı’ya yeni görevinde başarılarılarının devamını diledik. Viranşehir ilçe tarihinde ilk defa Viranşehir’de partilerinden bir kadın vekilin çıkmasından dolayı memnuniyetimizi dile getirdik.",
                  editDate: "2023-06-01T15:36:10",
                  imageName: "230601_154658_6344305.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 419,
                  title:
                    "TÜRKİYE BELEDİYELER BİRLİĞİ OLAĞAN MECLİS TOPLANTISINA KATILARAK TBB BAŞKANLIK SEÇİMİ İÇİN OYUMUZU KULLANDIK",
                  details:
                    "<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">T&uuml;rkiye Belediyeler Birliği olağan meclis toplantısına katılarak TBB Başkanlık se&ccedil;imi i&ccedil;in oyumuzu kullandık.</span></p>\n<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">Yapılan oylamada T&uuml;rkiye Belediyeler Birliği Başkanı se&ccedil;ilen Balıkesir B&uuml;y&uuml;kşehir Belediye Başkanımız Sn. Y&uuml;cel Yılmaz&rsquo;ı canı g&ouml;n&uuml;lden tebrik ediyor, yeni g&ouml;revinde muvaffakiyetler diliyorum.</span></p>\n<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">TBB Başkanlığı g&ouml;revini bug&uuml;ne kadar b&uuml;y&uuml;k bir başarı ile y&uuml;r&uuml;ten ve &ouml;nemli başarılara imza atan Gaziantep B&uuml;y&uuml;kşehir Belediye Başkanımız Sn. Fatma Şahin Hanımefendiye de g&uuml;zel hizmetleri i&ccedil;in teşekk&uuml;r ediyorum.</span></p>\n<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">Se&ccedil;imlerin &uuml;lkemize ve belediyelerimize hayırlı, uğurlu olmasını diliyorum.</span></p>",
                  description:
                    "TBB Başkanlığı görevini bugüne kadar büyük bir başarı ile yürüten ve önemli başarılara imza atan Gaziantep Büyükşehir Belediye Başkanımız Sn. Fatma Şahin Hanımefendiye de güzel hizmetleri için teşekkür ediyorum.",
                  editDate: "2023-05-31T14:50:33",
                  imageName: "230531_145201_3742135.webp",
                  imageCount: 4,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [
                    "230531_145223_1744336.webp",
                    "230531_145223_1725725.webp",
                    "230531_145223_1528602.webp",
                    "230531_145223_5222823.webp",
                  ],
                },
                {
                  id: 418,
                  title: "TÜRKİYE BELEDİYELER BİRLİĞİ MECLİS TOPLANTISI ANKARA",
                  details:
                    "<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">T&uuml;rkiye Belediyeler Birliği Meclis Toplantısı &bull;Ankara </span></p>\n<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">Ankara&rsquo;da d&uuml;zenlenen T&uuml;rkiye Belediyeler Birliği 2023 Mayıs ayı Olağan Meclis Toplantısı&rsquo;na katılım sağladık.</span></p>\n<p class=\"MsoNormal\" style=\"text-align: justify;\"><span style=\"font-size: 12.0pt; line-height: 115%; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: TR;\">Meclis toplantımızın hayırlara vesile olmasını temenni ediyorum.</span></p>",
                  description:
                    "Ankara’da düzenlenen Türkiye Belediyeler Birliği 2023 Mayıs ayı Olağan Meclis Toplantısı’na katılım sağladık.",
                  editDate: "2023-05-31T12:33:57",
                  imageName: "230531_123600_9504565.webp",
                  imageCount: 3,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [
                    "230531_123618_7647809.webp",
                    "230531_123618_7514404.webp",
                    "230531_123618_7514423.webp",
                  ],
                },
                {
                  id: 417,
                  title:
                    "AK PARTİ GENEL BAŞKANIMIZ VE CUMHURBAŞKANIMIZ SN. RECEP TAYYİP ERDOĞAN’IN TENSİPLERİYLE AK PARTİ TBMM GRUP BAŞKANLIĞI GÖREVİNE GETİRİLEN",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">AK Parti Genel Başkanımız ve Cumhurbaşkanımız Sn. Recep Tayyip Erdoğan&rsquo;ın tensipleriyle AK Parti TBMM Grup Başkanlığı g&ouml;revine getirilen Sn. Abdullah G&uuml;ler&rsquo;i ve Grup Başkanvekilliği g&ouml;revlerine getirilen Sn. Abdulhamit G&uuml;l&rsquo;&uuml;, Sn. Mehmet Emin Akbaşoğlu&rsquo;nu, Sn. &Ouml;zlem Zengin&rsquo;i, Sn. Leyla Şahin Usta&rsquo;yı ve Sn. Bahadır Yenişehirlioğlu&rsquo;nu canı g&ouml;n&uuml;lden tebrik ediyor, yeni g&ouml;revlerinde muvaffakiyetler diliyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Gazi Meclisimize ve aziz milletimize hayırlı, uğurlu olsun. Rabbim hayırlı hizmetlerde bulunmayı nasip eylesin.</span></p>',
                  description:
                    "Sn. Abdullah Güler’i ve Grup Başkanvekilliği görevlerine getirilen Sn. Abdulhamit Gül’ü, Sn. Mehmet Emin Akbaşoğlu’nu, Sn. Özlem Zengin’i, Sn. Leyla Şahin Usta’yı ve Sn. Bahadır Yenişehirlioğlu’nu canı gönülden tebrik ediyor",
                  editDate: "2023-05-31T10:33:59",
                  imageName: "230531_103448_5250322.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 416,
                  title: "TEBRİKLER ŞAMPİYON GALATASARAY",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Tebrikler Şampiyon #Galatasaray🏆👏⚽</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Spor Toto S&uuml;per Lig 2022-2023 sezonunu şampiyon olarak tamamlayan Galatasaray Futbol Kul&uuml;b&uuml;n&uuml;, sporcularını, teknik heyetini, y&ouml;netimini ve t&uuml;m taraftarlarını canı g&ouml;n&uuml;lden tebrik ediyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">#ȘampiyonGalatasaray</span></p>',
                  description:
                    "Spor Toto Süper Lig 2022-2023 sezonunu şampiyon olarak tamamlayan Galatasaray Futbol Kulübünü, sporcularını, teknik heyetini, yönetimini ve tüm taraftarlarını canı gönülden tebrik ediyorum.",
                  editDate: "2023-05-31T10:28:04",
                  imageName: "230531_102921_8553248.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 414,
                  title:
                    "GAZİANTEP-NURDAĞI OTOYOLUNDA KAZA YAPAN MEVSİMLİK TARIM İŞÇİLERİMİZ TRAFİK KAZASINDA HAYATINI KAYBEDEN HEMŞEHRİLERİMİZE ALLAH’TAN RAHMET, DİLİYORUM",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Gaziantep-Nurdağı otoyolunda mevsimlik tarım iş&ccedil;ilerimizi taşıyan minib&uuml;s ile tırın &ccedil;arpışması sonucu meydana gelen zincirleme trafik kazasında hayatını kaybeden hemşehrilerimize Allah&rsquo;tan rahmet, kederli ailelerine ve yakınlarına sabır ve başsağlığı, yaralanan hemşehrilerimize de Y&uuml;ce Rabbimden acil şifalar diliyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Acımız b&uuml;y&uuml;k, başımız sağ olsun.</span></p>',
                  description:
                    "meydana gelen zincirleme trafik kazasında hayatını kaybeden hemşehrilerimize Allah’tan rahmet, kederli ailelerine ve yakınlarına sabır ve başsağlığı, yaralanan hemşehrilerimize de Yüce Rabbimden acil şifalar diliyorum.",
                  editDate: "2023-05-30T08:10:10",
                  imageName: "230530_081453_4699791.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 413,
                  title:
                    "İBRAHİM KAHRAMAN’IN KIYMETLİ EVLADI SERHAT KAHRAMAN VE MELEK AKYILDIZ ÇİFTİNİN NİŞAN MERASİMİNE KATILARAK, GENÇ ÇİFTİMİZİN NİŞAN YÜZÜKLERİNİ TAKTIK.",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Viranşehir Belediyemizde evlendirme memuru olarak g&ouml;rev yapan &ccedil;alışma arkadaşımız İbrahim Kahraman&rsquo;ın kıymetli evladı Serhat Kahraman ve Melek Akyıldız &ccedil;iftinin nişan merasimine katılarak, gen&ccedil; &ccedil;iftimizin nişan y&uuml;z&uuml;klerini taktık.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Evlilik yolunda ilk adımlarını atan gen&ccedil; &ccedil;iftimizi tebrik ediyor, mutluluklarının bir &ouml;m&uuml;r s&uuml;rmesini Y&uuml;ce Allah&rsquo;tan diliyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Rabbim tamamına erdirsin ve iki cihan saadeti nasip eylesin.</span></p>',
                  description:
                    "Evlilik yolunda ilk adımlarını atan genç çiftimizi tebrik ediyor, mutluluklarının bir ömür sürmesini Yüce Allah’tan diliyorum.",
                  editDate: "2023-05-30T08:04:52",
                  imageName: "230530_080730_4075644.webp",
                  imageCount: 5,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [
                    "230530_080751_5761469.webp",
                    "230530_080751_5340078.webp",
                    "230530_080751_5775633.webp",
                    "230530_080751_5447507.webp",
                    "230530_080751_5556214.webp",
                  ],
                },
                {
                  id: 412,
                  title:
                    "HARRAN BELEDİYE BAŞKANIMIZ MEHMET ÖZYAVUZ’UN KARDEŞİ VE AK PARTİ HARRAN İLÇE BAŞKANIMIZ MAHMUT ÖZYAVUZ’UN AMCASI ÖMER ÖZYAVUZ’UN TAZİYESİNE KATILDIK",
                  details:
                    '<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">&Ouml;nceki d&ouml;nem Harran Belediye Başkanımız Mehmet &Ouml;zyavuz&rsquo;un kardeşi ve AK Parti Harran İl&ccedil;e Başkanımız Mahmut &Ouml;zyavuz&rsquo;un Amcası &Ouml;mer &Ouml;zyavuz&rsquo;un Harran&rsquo;da d&uuml;zenlenen taziyesine katılarak, kederli ailesine ve yakınlarına baş sağlığı dileklerimizi ilettik.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Merhum &Ouml;mer &Ouml;zyavuz&rsquo;a Allah&rsquo;tan rahmet, kederli ailesine ve yakınlarına sabır ve baş sağlığı diliyorum.</span></p>\n<p class="MsoNormal" style="text-align: justify;"><span style="font-family: \'Times New Roman\',\'serif\';">Rabbim mekanını cennet, makamını &acirc;li eylesin.</span></p>',
                  description:
                    "Merhum Ömer Özyavuz’a Allah’tan rahmet, kederli ailesine ve yakınlarına sabır ve baş sağlığı diliyorum.",
                  editDate: "2023-05-30T07:59:27",
                  imageName: "230530_080429_5064552.webp",
                  imageCount: 3,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [
                    "230530_080931_1697485.webp",
                    "230530_080931_1696823.webp",
                    "230530_080931_1722938.webp",
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 123,
      name: "BaskanHakkinda",
      templateType: "Card",
      location: 0,
      elements: [
        {
          name: "foto",
          key: "6012023_13194884_baskan.png",
        },
      ],
      sections: [
        {
          name: "right",
          order: 1,
          contentType: "Content",
          categories: [
            {
              id: 2,
              text: "hakkimda",
              elements: [],
              contents: [
                {
                  id: 131,
                  title: "Hakkımda",
                  details:
                    '<p style="text-align: justify;">05 Şubat 1982 yılında Şanlıurfa İli Viranşehir İl&ccedil;esinde doğdu. İlk ve Orta &ouml;ğrenimini Viranşehir İl&ccedil;esinde tamamladı. Şanlıurfa Lisesini bitirdi. 2001 yılında &Ccedil;ukurova &Uuml;niversitesi Ziraat Fak&uuml;ltesi Bitkisel &Uuml;retim B&ouml;l&uuml;m&uuml;ne kayıt yaptırıp, Ocak 2006 yılında bitirdi. 2006 yılından itibaren Şanlıurfa İli Viranşehir İl&ccedil;esinde; Ziraat M&uuml;hendisi olarak Zirai İla&ccedil; Bayiliği yapmaktadır. Aralık 2017 yılında TMMOB Ziraat M&uuml;hendisleri Odası Y&ouml;netim Kurulu &Uuml;yesi olarak se&ccedil;ilmiştir. Viranşehir Ziraat M&uuml;hendisleri Derneği Kurucu &Uuml;yesidir. 2010 yılından itibaren AK Parti Viranşehir İl&ccedil;e Başkanlığı &Uuml;yeliği devam etmektedir. Orta d&uuml;zeyde İngilizce ve Arap&ccedil;a, İyi d&uuml;zeyde K&uuml;rt&ccedil;e bilmektedir. Evli ve iki &ccedil;ocuk babasıdır.&nbsp;</p>',
                  description: "\n",
                  editDate: "2022-10-14T14:19:16",
                  imageName: "",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 134,
                  title: "Belediye Başkanlığı\n",
                  details:
                    '<p style="text-align: justify;">31 Mart 2019 Mahalli Yerel Se&ccedil;imlerde Viranşehir İl&ccedil;e Belediye Başkanlığı i&ccedil;in m&uuml;racaat etmiş ve Sayın Cumhurbaşkanımız, Genel Başkanımızın ve AK Parti Genel Merkezinin onayı ile Viranşehir İl&ccedil;e Belediye Başkan Adayı olarak g&ouml;sterilmiştir. 31 Mart 2019 tarihinde yapılan genel mahalli idareler se&ccedil;iminde Viranşehir Belediye Başkanı olarak se&ccedil;ilmiştir.</p>',
                  description: "",
                  editDate: "2022-10-14T14:32:29",
                  imageName: "",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 135,
                  title: "Misyon & Vizyon",
                  details:
                    "<h3>Misyonumuz</h3>\n<p>İl&ccedil;emizde yaşam kalitesini artırmak i&ccedil;in belediyecilik hizmetlerini vatandaşların talep ve &ouml;nceliklerini dikkate alarak, insan odaklı, &ccedil;evreye duyarlı ve katılımcı bir anlayışla yerine getirmek.</p>\n<h3>Vizyonumuz</h3>\n<p>G&uuml;&ccedil;l&uuml; sanayisi, tarım ve hayvancılığı, lojistik yatırımları, turizmi ve &ccedil;evreye duyarlı kentleşmesini tamamlamış, yaşanabilir, g&uuml;venli ve mutlu bir Viranşehir</p>",
                  description: "\n",
                  editDate: "2022-10-14T14:49:02",
                  imageName: "",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
              ],
            },
          ],
        },
        {
          name: "left",
          order: 2,
          contentType: "Special",
          categories: [
            {
              id: 2,
              text: "hakkimda",
              elements: [],
              contents: [
                {
                  id: 131,
                  title: "Hakkımda",
                  details:
                    '<p style="text-align: justify;">05 Şubat 1982 yılında Şanlıurfa İli Viranşehir İl&ccedil;esinde doğdu. İlk ve Orta &ouml;ğrenimini Viranşehir İl&ccedil;esinde tamamladı. Şanlıurfa Lisesini bitirdi. 2001 yılında &Ccedil;ukurova &Uuml;niversitesi Ziraat Fak&uuml;ltesi Bitkisel &Uuml;retim B&ouml;l&uuml;m&uuml;ne kayıt yaptırıp, Ocak 2006 yılında bitirdi. 2006 yılından itibaren Şanlıurfa İli Viranşehir İl&ccedil;esinde; Ziraat M&uuml;hendisi olarak Zirai İla&ccedil; Bayiliği yapmaktadır. Aralık 2017 yılında TMMOB Ziraat M&uuml;hendisleri Odası Y&ouml;netim Kurulu &Uuml;yesi olarak se&ccedil;ilmiştir. Viranşehir Ziraat M&uuml;hendisleri Derneği Kurucu &Uuml;yesidir. 2010 yılından itibaren AK Parti Viranşehir İl&ccedil;e Başkanlığı &Uuml;yeliği devam etmektedir. Orta d&uuml;zeyde İngilizce ve Arap&ccedil;a, İyi d&uuml;zeyde K&uuml;rt&ccedil;e bilmektedir. Evli ve iki &ccedil;ocuk babasıdır.&nbsp;</p>',
                  description: "\n",
                  editDate: "2022-10-14T14:19:16",
                  imageName: "",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 134,
                  title: "Belediye Başkanlığı\n",
                  details:
                    '<p style="text-align: justify;">31 Mart 2019 Mahalli Yerel Se&ccedil;imlerde Viranşehir İl&ccedil;e Belediye Başkanlığı i&ccedil;in m&uuml;racaat etmiş ve Sayın Cumhurbaşkanımız, Genel Başkanımızın ve AK Parti Genel Merkezinin onayı ile Viranşehir İl&ccedil;e Belediye Başkan Adayı olarak g&ouml;sterilmiştir. 31 Mart 2019 tarihinde yapılan genel mahalli idareler se&ccedil;iminde Viranşehir Belediye Başkanı olarak se&ccedil;ilmiştir.</p>',
                  description: "",
                  editDate: "2022-10-14T14:32:29",
                  imageName: "",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 135,
                  title: "Misyon & Vizyon",
                  details:
                    "<h3>Misyonumuz</h3>\n<p>İl&ccedil;emizde yaşam kalitesini artırmak i&ccedil;in belediyecilik hizmetlerini vatandaşların talep ve &ouml;nceliklerini dikkate alarak, insan odaklı, &ccedil;evreye duyarlı ve katılımcı bir anlayışla yerine getirmek.</p>\n<h3>Vizyonumuz</h3>\n<p>G&uuml;&ccedil;l&uuml; sanayisi, tarım ve hayvancılığı, lojistik yatırımları, turizmi ve &ccedil;evreye duyarlı kentleşmesini tamamlamış, yaşanabilir, g&uuml;venli ve mutlu bir Viranşehir</p>",
                  description: "\n",
                  editDate: "2022-10-14T14:49:02",
                  imageName: "",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 124,
      name: "galeri",
      templateType: "Card",
      location: 0,
      elements: [
        {
          name: "foto",
          key: "6012023_13194892_baskan.png",
        },
      ],
      sections: [
        {
          name: "foto",
          order: 1,
          contentType: "Content",
          categories: [
            {
              id: 4,
              text: "FOTOĞRAFLAR",
              elements: [],
              contents: [
                {
                  id: 415,
                  title: "Salih EKİNCİ",
                  details: "",
                  description: "Salih EKİNCİ",
                  editDate: "2023-05-30T08:49:44",
                  imageName: "230530_084957_4775839.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 320,
                  title: "resim 16",
                  details: "",
                  editDate: "2023-02-01T14:28:40",
                  imageName: "1022023_142846148_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 303,
                  title: "viranşehir resim-24",
                  details: "",
                  editDate: "2023-01-31T15:41:09",
                  imageName: "1312023_34116_PM594_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 308,
                  title: "viranşehir resim-27",
                  details: "",
                  editDate: "2023-01-31T15:41:52",
                  imageName: "1312023_34200_PM747_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 307,
                  title: "viranşehir resim-26",
                  details: "",
                  editDate: "2023-01-31T15:41:34",
                  imageName: "1312023_34140_PM798_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 304,
                  title: "viranşehir resim-25",
                  details: "",
                  editDate: "2023-01-31T15:41:21",
                  imageName: "1312023_34128_PM322_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
              ],
            },
          ],
        },
        {
          name: "vedio",
          order: 2,
          contentType: "Content",
          categories: [
            {
              id: 5,
              text: "VİDEOLAR",
              elements: [],
              contents: [
                {
                  id: 123,
                  title:
                    "BAŞKAN EKİNCİ, YKS ŞAMPİYONLARINI BİLGİSAYARLA ÖDÜLLENDİRDİ",
                  details: "<span>null</span>",
                  url: "https://youtu.be/jUVoEtnPwH8",
                  editDate: "2022-10-14T11:33:48",
                  imageName: "5012023_111711540_18_08_2022_14_5.jpg",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 140,
                  title:
                    "BAŞKAN EKİNCİ VE KAYMAKAM ÇENGEL GAZETECİLERLE BİR ARAYA GELDİ",
                  details: "<span>null</span>",
                  url: "https://youtu.be/floA1g_M8gE",
                  editDate: "2022-10-14T16:53:31",
                  imageName: "1022023_125013761_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 127,
                  title:
                    "VİRANŞEHİR DERİK BAĞLANTI YOLUNDA STABİLİZE YOL ÇALIŞMASI",
                  details: "<span>null</span>",
                  url: "https://youtu.be/9u6ouLKN5yU",
                  editDate: "2022-10-14T11:39:38",
                  imageName: "5012023_09532355_1_12_2021_15_10.jpg",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 125,
                  title: "BAŞKAN EKİNCİ: YENİŞEHİR’İ YENİDEN İNŞA EDİYORUZ",
                  details: "<span>null</span>",
                  url: "https://youtu.be/Ay3DH87eoPY",
                  editDate: "2022-10-14T11:35:14",
                  imageName: "1022023_124759291_.webp",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [],
                },
                {
                  id: 170,
                  title: "BÜYÜKŞEHİR SICAK ASFALT ÇALIŞMALARINI SÜRDÜRÜYOR",
                  details: "<span>null</span>",
                  url: "https://youtu.be/IT9FAximG2Q",
                  editDate: "2023-01-05T11:42:42",
                  imageName: "1022023_125659317_.webp",
                  imageCount: 3,
                  fileCount: 0,
                  elements: [],
                  fileNames: [],
                  imageNames: [
                    "1272023_104528_AM173_.jpeg",
                    "1272023_104527_AM438_.png",
                    "1272023_104527_AM189_.png",
                  ],
                },
                {
                  id: 126,
                  title: "BAŞKAN EKİNCİ, VİRANŞEHİR BELEDİYESPOR’A MORAL VERDİ",
                  details: "<span>null</span>",
                  url: "https://youtu.be/zq258uJsdhY",
                  editDate: "2022-10-14T11:38:16",
                  imageName: "4012023_17322587_28_09_2022_10_5.jpg",
                  imageCount: 0,
                  fileCount: 0,
                  elements: [
                    {
                      name: "fazla bilgiler",
                      adres: "",
                      adiSoyAd: "",
                      telefon: "",
                      unvan: "",
                      email: "",
                      detay: "",
                      list: [],
                    },
                  ],
                  fileNames: [],
                  imageNames: [],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 125,
      name: "Iletisim",
      templateType: "Card",
      location: 0,
      elements: [],
      sections: [
        {
          name: "right",
          order: 1,
          contentType: "Content",
          categories: [
            {
              id: 6,
              text: "ulasim",
              elements: [],
              contents: [],
            },
          ],
        },
      ],
    },
  ],
};
export default tmHome;
